import React, {useCallback, useEffect, useRef, useState} from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import MarkdownPreview from '@uiw/react-markdown-preview';

import { getLocal, ONBOARDING_SLIDES, PROFILE_CATEGORIES, PROFILE_MIN_PARAMS, PROFILE_PARAMS, PROFILE_PROMPT, PROFILE_POLLING_ATTEMPTS, PROFILE_POLLING_INTERVAL, sendActivityMessage, sendActivityMessageStreaming, sendChatMessage, sendChatMessageStreaming, sendProfileMessage, sendProfileMessageStreaming, setLocal, syncProfile, updateActivity, updateProfile, updateTask, wait } from '../../utils/api';
import useLinkReachabilityProbe from '../../utils/useLinkReachabilityProbe';

import './Transcript.css';

const isSameValue = (a, b) => {
  if ((a === null || a === undefined) && (b === null || b === undefined)) {
    return true;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }

    return a.every((v, i) => v === b[i]);
  }

  return a === b;
};

function Transcript({ activity, handleConfetti, handleError, handlePath, isProfile, transcript }) {
  const location = useLocation();
  const { taskId } = useParams();
  const navigate = useNavigate();
  const ref = useRef(null);
  const refs = useRef({});

  const [isDragging, setIsDragging] = useState(false);
  const [isProfileSending, setIsProfileSending] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [messageStream, setMessageStream] = useState('');
  const [messageStreamState, setMessageStreamState] = useState(null);
  const [profile, setProfile] = useState(isProfile ? getLocal('profile') : false);
  const [profileEdit, setProfileEdit] = useState(null);
  const [profileMessage, setProfileMessage] = useState('');
  const [profilePollingAttempt, setProfilePollingAttempt] = useState(0);
  const [profileRemove, setProfileRemove] = useState(null);
  const [profileUpdates, setProfileUpdates] = useState({});
  const [scrollToResponse, setScrollToResponse] = useState(false);
  const [showLink, setShowLink] = useState(false);
  const [showLinkCopied, setShowLinkCopied] = useState(false);
  const [showTranscript, setShowTranscript] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [transcriptHeight, setTranscriptHeight] = useState(0);

  const handlePlan = useCallback((taskId) => {
    navigate('/plan/' + taskId, { state: { from: location.pathname }});
  }, [location, navigate]);

  const renderMessages = () => {
    let contents = [];
    let contentIndex = 0;
    /*
    let sortedTasks = tasks.sort((a, b) => a.order - b.order);

    if (activity) {
      let activeTask = null;

      if (sortedTasks.every(task => task.status === 'not_started' || task.status === 'completed')) {
        activeTask = sortedTasks.findIndex(task => task.status === 'not_started');
      }

      contents.push(
        <div key={contentIndex++} className={'button activity ' + (activity.activity.type || 'career') + (' ' + activity.activity.status)}>
          <div className="button-inner">
            <div className="button-title">{activity.activity.title}</div>
          </div>
          {sortedTasks.length ? (
            <div className="tasks">
              {sortedTasks.map((task, taskIndex) => {
                let classes = ['task'];

                if (activity.activity.status === 'completed') {
                  classes.push('completed');
                } else if (taskIndex === activeTask) {
                  classes.push('in_progress');
                } else {
                  classes.push(task.status || 'not_started');
                }

                return (
                  <div key={taskIndex} className={classes.join(' ')}>
                    <div className="task-title">{task.title}</div>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      );
    }
    */
    if (messages?.length) {
      contents.push(messages.map((message, messageIndex) => {
        let messageContents = [];
        let messageContentIndex = 0;
        /*
        if (activity && message.tasks?.length) {
          const completedTask = message.tasks.findLastIndex(task => task.status === 'completed');

          if (completedTask >= 0 && completedTask < message.tasks.length - 1 && message.tasks[completedTask + 1].status === 'in_progress' && message.tasks[completedTask + 1].stage === 'introduction') {
            messageContents.push(
              <div key={messageContentIndex++} className={'button activity ' + (activity.activity.type || 'career') + ' completed'}>
                <div className="button-inner">
                  <div className="button-title">Fantastic, you're making great progress!</div>
                  <div className="button-title">Would you like to see your updated <a onClick={() => handlePlan(message.tasks[completedTask]._id)}>Plan</a>?</div>
                </div>
              </div>
            );
          }
        }
        */
        if (isProfile && messageIndex < messages.length - 1) {
          return null;
        }

        messageContents.push(
          <React.Fragment key={messageContentIndex++}>
            {((activity === false || messageIndex) && !isProfile) ? (
              <div className="chat">{message.message}</div>
            ) : null}
            <div className="bubble">
              <MarkdownPreview source={message.response} components={{ a: ({ children, href, ...markdownProps }) => (
                href.startsWith('/') ? (
                  <a href={href} {...markdownProps}>{children}</a>
                ) : (
                  <a href={href} target="_blank" rel="noopener noreferrer" /*onClick={handleLinkProbe}*/ {...markdownProps}>{children}</a>
                )
              )}} />
            </div>
            {!isProfile && message.topics?.length && message.topics[0].question && message.topics[0].topic ? (
              <div className="topics">
                <div className="topics-title">Suggested Topics</div>
                <ul>
                  {message.topics.map((topic, topicIndex) => {
                    if (topic.question && topic.topic) {
                      return (
                        <li key={topicIndex} onClick={() => postMessage(topic.question, message._id)}>{topic.topic}</li>
                      );
                    } else {
                      return null;
                    }
                  })}
                </ul>
              </div>
            ) : null}
          </React.Fragment>
        );

        return <React.Fragment key={contentIndex++}>{messageContents}</React.Fragment>;
      }));
    }
    /*
    if (!isSending && activity?.activity?.status !== 'completed') {
      const completingTask = sortedTasks.findIndex(task => task.status === 'in_progress' && task.stage === 'check_in');

      if (completingTask >= 0) {
        if (completingTask === sortedTasks.length - 1) {
          contents.push(
            <div key={contentIndex++} className={'button activity ' + (activity.activity.type || 'career') + ' completed'}>
              <div className="button-inner">
                <div className="button-title">Have you completed the "{activity.activity.title}" activity?</div>
              </div>
              <div className="actions">
                <div className="action action-primary" onClick={() => completeActivity(activity.activity._id, sortedTasks[completingTask]._id)}>Yes</div>
                <div className="action action-secondary" onClick={() => continueTask()}>No</div>
              </div>
            </div>
          );
        } else {
          contents.push(
            <div key={contentIndex++} className="goal">
              <div className="goal-header">
                <div className="goal-icon"></div>
                <div className="goal-text">
                  <div className="goal-title">{sortedTasks[completingTask].title}</div>
                  <div className="goal-description">Are you finished with this task?</div>
                </div>
              </div>
              <div className="goal-buttons">
                <div className="goal-button goal-button-primary" onClick={() => completeTask(sortedTasks[completingTask]._id)}>Yes</div>
                <div className="goal-button goal-button-secondary" onClick={() => continueTask()}>No</div>
              </div>
            </div>
          );
        }
      }
    }
    */
    if (isSending) {
      contents.push(
        <React.Fragment key={contentIndex++}>
          {(activity === false || messages?.length) && (!isProfile || isSending !== PROFILE_PROMPT) ? (
            <div className="chat">{isSending}</div>
          ) : null}
          <div className={'bubble' + (messageStreamState ? ' ' + messageStreamState : '')}>
            {messageStream ? (
              <MarkdownPreview source={messageStream} />
            ) : (
              <div className="ellipses">
                <div className="ellipsis"></div>
                <div className="ellipsis"></div>
                <div className="ellipsis"></div>
              </div>
            )}
          </div>
        </React.Fragment>
      );
    }

    if (isProfile) {
      return <div className="overflow">{contents}</div>;
    }

    return contents;
  };

  const handleCopy = useCallback(async (href) => {
    try {
      await navigator.clipboard.writeText(href);
      setShowLinkCopied(true);
    } catch (e) {
      handleError(e);
    }
  }, [handleError]);

  const handleLink = useCallback((href) => {
    window.open(href, '_blank', 'noopener,noreferrer');
    setShowLink(false);
  }, []);

  const handleLinkProbe = useLinkReachabilityProbe({
    onUnreachable: (href) => {
      setShowLink(href);
      setShowLinkCopied(false);
    }
  }, []);

  const handleProfile = useCallback(() => {
    navigate('/profile');
  }, [navigate]);

  const handleProfileUpdate = useCallback((newProfile) => {
    let isProfileUpdated = false;
    let profileUpdates = {};

    if (newProfile.meta_data?.length) {
      newProfile.meta_data.forEach(newItem => {
        let isItemUpdated = false;

        if (profile.meta_data?.length) {
          const item = profile.meta_data.find(item => item.param === newItem.param);

          if (item) {
            isItemUpdated = !isSameValue(item.value, newItem.value);
          } else {
            isItemUpdated = true;
          }
        } else {
          isItemUpdated = true;
        }

        if (isItemUpdated) {
          isProfileUpdated = true;
          profileUpdates[newItem.param] = true;
        }
      });
    }

    setProfile(newProfile);
    setProfileUpdates(profileUpdates);

    if (isProfileUpdated) {
      handleConfetti();
      setProfilePollingAttempt(0);
    } else if (PROFILE_POLLING_ATTEMPTS > 0) {
      setProfilePollingAttempt(prevProfilePollingAttempt => (prevProfilePollingAttempt === PROFILE_POLLING_ATTEMPTS ? 0 : ++prevProfilePollingAttempt));
    }
  }, [handleConfetti, profile]);

  const handleProfileUpdated = useCallback((param) => {
    setProfileUpdates(prevProfileUpdates => {
      if (param in prevProfileUpdates) {
        prevProfileUpdates[param] = false;
      }

      return prevProfileUpdates;
    });
  }, []);

  const handleMessageStreaming = useCallback(async (stream, onComplete) => {
    if (stream !== null) {
      const reader = stream.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          break;
        }

        buffer += decoder.decode(value, { stream: true });

        const events = buffer.split('\n\n');
        buffer = events.pop();

        for (const block of events) {
          if (!block.trim() || block.startsWith(':')) {
            continue;
          }

          let eventType = 'message';
          let data = '';

          for (const line of block.split('\n')) {
            if (line.startsWith('event:')) {
              eventType = line.slice(6).trim();
            } else if (line.startsWith('data:')) {
              data = line.slice(5).trim();
            }
          }

          if (!data) {
            continue;
          }

          const parsed = JSON.parse(data);
          
          switch (eventType) {
            case 'chunk':
              setMessageStream(prevMessageStream => prevMessageStream + parsed.text);
              setMessageStreamState(eventType);
              break;
            case 'complete':
            case 'error':
            case 'moderation':
              stream = onComplete(parsed);
              setMessageStreamState(null);
              break;
            default:
              setMessageStreamState(null);
              break;
          }
        }
      }
    }

    return stream;
  }, []);

  const postMessage = useCallback(async (message, parentMessageId = null) => {
    if (!isSending && message?.length) {
      setMessage('');
      setMessageStream('');
      setMessageStreamState(null);


      setIsSending(message);
      
      try {
        const isStreaming = (process.env.REACT_APP_MESSAGE_STREAMING === '1');
        let response;

        if (activity === false && !isProfile) {
          if (isStreaming) {
            response = await handleMessageStreaming(await sendChatMessageStreaming(message, parentMessageId), stream => ({
              message: (stream.blocked || stream.retryable ? { message: message, response: stream.message } : stream.messages[0]),
              profile: stream.profile
            }));
          } else {
            response = await sendChatMessage(message, parentMessageId);
          }
        } else if (activity) {
          if (isStreaming) {
            response = await handleMessageStreaming(await sendActivityMessageStreaming(activity.activity._id, message, parentMessageId), stream => ({
              message: (stream.blocked || stream.retryable ? { message: message, response: stream.message } : stream.latestMessage),
              profile: null,
              tasks: stream.latestMessage?.tasks?.length ? stream.latestMessage.tasks : []
            }));
          } else {
            response = await sendActivityMessage(activity.activity._id, message, parentMessageId);
          }
        } else if (isProfile) {
          if (isStreaming) {
            response = await handleMessageStreaming(await sendProfileMessageStreaming(message, parentMessageId), stream => ({
              message: (stream.blocked || stream.retryable ? { message: message, response: stream.message } : stream.message),
              profile: stream.profile
            }));
          } else {
            response = await sendProfileMessage(message, parentMessageId);
          }
        }

        if (response !== null) {
          setIsSending(false);
          setMessageStream('');
          setMessageStreamState(null);
          setScrollToResponse(true);
          setMessages(prevMessages => [...prevMessages, response.message]);
          
          if (response.profile) {
            setLocal('profile', response.profile);

            if (isProfile && message !== PROFILE_PROMPT) {
              handleProfileUpdate(response.profile);
            } else {
              setProfile(response.profile);
            }
          }

          if (response.tasks) {
            setTasks([...response.tasks]);
          }

          if (isProfile) {
            if (message !== PROFILE_PROMPT) {
              setShowTranscript(false);
            }
          } else if (ref?.current) {
            setTimeout(() => {
              ref.current.focus();
            }, 100);
          }
        }
      } catch (e) {
        handleError(e);
        setMessage(message);
        setMessageStream('');
        setMessageStreamState(null);
        setIsSending(false);
      }
    }
  }, [activity, handleError, handleMessageStreaming, handleProfileUpdate, isProfile, isSending]);

  const completeActivity = useCallback(async (id, taskId, hasRedirect = true) => {
    try {
      if (taskId) {
        await updateTask(taskId, 'completed');
      }

      const response = updateActivity(id, 'completed');

      if (response !== null) {
        handleConfetti();

        if (hasRedirect) {
          navigate('/path');
        }
      }
    } catch (e) {
      handleError(e);
    }
  }, [handleConfetti, handleError, navigate]);

  const completeTask = useCallback(async (id) => {
    try {
      const response = await updateTask(id, 'completed');

      if (response !== null) {
        handleConfetti();

        await postMessage('Yes, I\'m finished with this task.');
      }
    } catch (e) {
      handleError(e);
    }
  }, [handleConfetti, handleError, postMessage]);

  const continueTask = useCallback(async () => {
    try {
      await postMessage('No, I\'m not finished with this task yet.');
    } catch (e) {
      handleError(e);
    }
  }, [handleError, postMessage]);

  const showSuccessMessage = useCallback((message) => {
    setSuccessMessage(message);
  }, []);

  const handleDragging = useCallback((e) => {
    setIsDragging(true);
    e.preventDefault();

    const onMouseMove = (event) => {
      setTranscriptHeight(transcriptHeight + (e.clientY - event.clientY));
    };

    const onMouseUp = () => {
      setIsDragging(false);

      document.body.removeEventListener('mousemove', onMouseMove);
      document.body.removeEventListener('mouseup', onMouseUp);
    };

    document.body.addEventListener('mousemove', onMouseMove);
    document.body.addEventListener('mouseup', onMouseUp, { once: true });
  }, [transcriptHeight]);

  const handleInput = useCallback((e) => {
    setMessage(e.target.value);
  }, []);

  const handleKey = useCallback(async (e) => {
    const message = e.target.value;

    if (e.keyCode === 13) {
      try {
        await postMessage(message);
      } catch (e) {
        handleError(e);
      }
    }
  }, [handleError, postMessage]);

  const handleProfileSubmit = useCallback(async (message, item) => {
    if (isProfileSending) {
      return;
    }

    const isPillCase = !item && profileEdit && Array.isArray(profileEdit.value);
    const targetItem = item || profileEdit;

    if (!targetItem) {
      return;
    }

    setProfileMessage('');

    let value;
    let originalValue;

    if (isPillCase) {
      value = profileEdit.value.length ? profileEdit.value : null;
      originalValue = profile?.meta_data?.find(metaItem => metaItem.param === targetItem.param)?.value;
    } else {
      value = (message || null);
      originalValue = targetItem.value;
    }

    if (isSameValue(value, originalValue)) {
      setProfileEdit(null);
      return;
    }

    if (!isPillCase) {
      let errors = [];

      if (targetItem.validations?.length && value) {
        targetItem.validations.forEach(validation => {
          if (!validation.regex?.test(value)) {
            errors.push(validation.error);
          }
        });
      }

      if (errors.length) {
        setProfileEdit({ ...targetItem, errors });
        setProfileMessage(message);
        return;
      }
    }

    setIsProfileSending(isPillCase ? true : message);

    try {
      const response = await updateProfile(targetItem.param, value);

      if (response !== null) {
        if (targetItem.successMessage) {
          showSuccessMessage(targetItem.successMessage);
        }

        setIsProfileSending(false);
        handleProfileUpdate(response);
        setProfileEdit(null);
      }
    } catch (e) {
      handleError(e);

      if (!isPillCase) {
        setProfileMessage(message);
      }

      setIsProfileSending(false);
    }
  }, [handleError, handleProfileUpdate, isProfileSending, profile, profileEdit, showSuccessMessage]);

  const handleProfilePillAdd = useCallback((message) => {
    const value = (message || '').trim();

    if (!value) {
      return;
    }

    setProfileEdit(prevItem => {
      if (!prevItem || !Array.isArray(prevItem.value)) {
        return prevItem;
      }

      if (prevItem.value.includes(value)) {
        return prevItem;
      }

      return { ...prevItem, value: [...prevItem.value, value] };
    });

    setProfileMessage('');
  }, []);

  const handleProfilePillRemove = useCallback((index) => {
    setProfileEdit(prevItem => {
      if (Array.isArray(prevItem?.value)) {
        prevItem.value.splice(index, 1);
      }

      return {...prevItem};
    });
  }, []);

  const handleProfileInput = useCallback((e) => {
    setProfileMessage(e.target.value);
  }, []);

  const handleProfileKey = useCallback(async (e, item, isPillMode) => {
    const message = e.target.value;

    if (e.keyCode === 13) {
      try {
        if (isPillMode) {
          handleProfilePillAdd(message);
        } else {
          await handleProfileSubmit(message, item);
        }
      } catch (e) {
        handleError(e);
      }
    }
  }, [handleError, handleProfilePillAdd, handleProfileSubmit]);

  const handleRemove = useCallback(async (item) => {
    try {
      const response = await updateProfile(item.param, null);

      if (response !== null) {
        handleProfileUpdate(response);
        setProfileRemove(null);
      }
    } catch (e) {
      handleError(e);
    }
  }, [handleError, handleProfileUpdate]);

  const handleTranscript = useCallback((showTranscript) => {
    if (isProfile) {
      setShowTranscript(showTranscript);
    }
  }, [isProfile]);

  const showEdit = useCallback((show, item) => {
    const slide = ONBOARDING_SLIDES.find(slide => slide.param === item.param);
    let editingItem = {...item};

    if (slide) {
      editingItem.type = slide.input;
    } else {
      editingItem.type = 'text';
    }

    if (editingItem.type === 'multiselect' || editingItem.type === 'select') {
      editingItem.value = (Array.isArray(editingItem.value) ? [...editingItem.value] : editingItem.value?.split(', '));

      setProfileMessage('');
    } else {
      setProfileMessage(show && editingItem.value ? (Array.isArray(editingItem.value) ? editingItem.value.join(', ') : editingItem.value) : '');
    }

    setProfileEdit(show ? editingItem : null);
  }, []);

  const showRemove = useCallback((show, item) => {
    setProfileRemove(show ? item : null);
  }, []);

  useEffect(() => {
    if (Array.isArray(transcript)) {
      let hasPostedMessage = false;

      if (taskId && Array.isArray(activity?.activity?.tasks) && activity.activity.tasks.length) {
        const task = activity.activity.tasks.find(task => task._id === taskId);

        if (task?.description) {
          postMessage(task.description);
          hasPostedMessage = true;
        }
      }

      if (transcript.length) {
        setMessages([...transcript]);
        /*
        if (activity && Array.isArray(transcript[transcript.length - 1].tasks) && transcript[transcript.length - 1].tasks.length) {
          setTasks([...transcript[transcript.length - 1].tasks]);
        } else {*/
          setTasks([]);
        //}
      } else {
        setMessages([]);
        /*
        if (Array.isArray(activity?.activity?.tasks) && activity.activity.tasks.length) {
          const tasks = [...activity.activity.tasks];

          postMessage(tasks[0].description);
          
          setTasks(tasks);
        } else {
          if (activity?.activity?.type === 'start') {
            if (activity.activity.status !== 'completed') {
              completeActivity(activity.activity._id, null, false);
            }
            */
            if (!hasPostedMessage && activity?.activity?.prompt_for_more_info) {
              postMessage(activity.activity.prompt_for_more_info);
            } else if (isProfile) {
              postMessage(PROFILE_PROMPT);
            }
          //}

          setTasks([]);
        //}
      }
    }
  }, [activity, isProfile, taskId, transcript]);

  useEffect(() => {
    if (scrollToResponse) {
      const responses = document.querySelectorAll('#transcript .transcript .response');

      if (responses.length) {
        const response = responses[responses.length - 1];

        if (response) {
          response.scrollIntoView();
        }
      }

      setScrollToResponse(false);
    } else {
      const transcript = document.querySelector('#transcript .transcript');

      if (transcript) {
        transcript.scrollTop = transcript.scrollHeight;
      }
    }
  }, [isSending, messages]);

  useEffect(() => {
    if (!isProfile && ref?.current) {
      setTimeout(() => {
        ref.current.focus();
      }, 100);
    }
  }, [isProfile]);
  
  useEffect(() => {
    if (!profilePollingAttempt) {
      return;
    }
    
    (async () => {
      try {
        await wait(PROFILE_POLLING_INTERVAL);
        
        const response = await syncProfile();

        if (response.status === 200 && response.data) {
          handleProfileUpdate(response.data);
        }
      } catch (e) {
        handleError(e);
      }
    })();
  }, [handleError, handleProfileUpdate, profilePollingAttempt]);

  return (
    <>
      <div id="transcript" className={activity === false && !isProfile && !isSending && !messages?.length ? 'empty' : (showTranscript ? 'show' : '')}>
        {isProfile ? (
          <div className="close light" onClick={handleProfile}></div>
        ) : (
          <div className="back" onClick={handlePath}>Back</div>
        )}
        {activity || isProfile ? (
          <div className="section-title">
            {activity ? (
              <>{activity.activity?.title}</>
            ) : (
              <>The Details Behind Your Story</>
            )}
          </div>
        ) : null}
        {isProfile ? (
          <div className="profile overflow">
            {profile.meta_data?.length ? (
              <>
                {profile.meta_data.filter(item => item.value).length < PROFILE_MIN_PARAMS ? (
                  <div className="callout">Hi! I don't know much about you yet!</div>
                ) : null}
                <div className="profile-categories">
                  {PROFILE_CATEGORIES.map((category, categoryIndex) => {
                    if (!profile.meta_data.filter(item => item.category === category.name).length && !PROFILE_PARAMS.filter(item => item.category === category.name).length) {
                      return null;
                    }

                    return (
                      <div key={categoryIndex} className={'button profile-category ' + (category.name)}>
                        <div className="button-inner">
                          <div className="button-title">{category.label}</div>
                        </div>
                        <div className="profile-items">
                          {profile.meta_data.filter(item => item.category === category.name).map((item, itemIndex) => {
                            const isCurrentItem = (profileEdit?.param === item.param);
                            const isPillMode = isCurrentItem && Array.isArray(profileEdit.value);

                            return (
                              <div key={itemIndex} className={'profile-item' + (isCurrentItem ? ' editing' : '') + (item.param in profileUpdates && profileUpdates[item.param] ? ' updated' : '')} onAnimationEnd={() => handleProfileUpdated(item.param)}>
                                <div className="profile-item-title">{item.label}</div>
                                {(isCurrentItem && Array.isArray(profileEdit.value)) || (!isCurrentItem && Array.isArray(item.value)) ? (
                                  <div className="pills">
                                    {((isCurrentItem && profileEdit) || item).value.map((pill, pillIndex) => 
                                      <div key={pillIndex} className="pill pill-theme-2">
                                        {pill}
                                        {isCurrentItem ? (
                                          <div className="pill-delete" title="Remove" onClick={() => handleProfilePillRemove(pillIndex)}></div>
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="profile-item-description">{item.value}</div>
                                )}
                                <div className="text-input">
                                  <input ref={element => refs.current[item.param] = element} name="input" autoComplete="off" placeholder={isProfileSending ? 'Give me a sec...' : (isPillMode ? '' : 'Tell your AI Guide')} value={profileMessage} disabled={!!isProfileSending} onChange={(e) => handleProfileInput(e)} onKeyDown={(e) => handleProfileKey(e, item, isPillMode)}></input>
                                  <div className="text-submit" onClick={() => isPillMode ? handleProfilePillAdd(profileMessage) : handleProfileSubmit(profileMessage, item)}></div>
                                </div>
                                <div className="profile-actions">
                                  <div className="profile-action edit" title="Edit" onClick={() => showEdit(true, item)}></div>
                                  <div className="profile-action remove" title="Remove" onClick={() => showRemove(true, item)}></div>
                                  {isPillMode ? (
                                    <div className="profile-action save" title="Save" onClick={() => handleProfileSubmit()}></div>
                                  ) : null}
                                  <div className="profile-action cancel" title="Cancel" onClick={() => showEdit(false, item)}></div>
                                </div>
                              </div>
                            );
                          })}
                          {PROFILE_PARAMS.filter(item => item.category === category.name).map((item, itemIndex) => {
                            return (
                              <div key={itemIndex} className={'profile-item' + (profileEdit?.param === item.name ? ' editing' : '')}>
                                <div className="profile-item-title">{item.label}</div>
                                {item.notes ? (
                                  <div className="profile-item-notes">{item.notes}</div>
                                ) : null}
                                <div className="profile-item-description">{profile[item.name]}</div>
                                <div className="text-input">
                                  <input ref={element => refs.current[item.name] = element} name="input" autoComplete='off' placeholder={isProfileSending ? 'Give me a sec...' : (item.placeholder || 'Tell your AI Guide')} value={profileMessage} disabled={!!isProfileSending} onChange={(e) => handleProfileInput(e)} onKeyDown={(e) => handleProfileKey(e, { ...item, param: item.name, value: profile[item.name] })}></input>
                                  <div className="text-submit" onClick={() => handleProfileSubmit(profileMessage, { ...item, param: item.name, value: profile[item.name] })}></div>
                                </div>
                                {profileEdit?.param === item.name && profileEdit?.errors?.length ? (
                                  <div className="profile-item-errors">
                                    {profileEdit.errors.map((error, errorIndex) =>
                                      <div key={errorIndex} className="profile-item-error">{error}</div>
                                    )}
                                  </div>
                                ) : null}
                                <div className="profile-actions">
                                  <div className="profile-action edit" title="Edit" onClick={() => showEdit(true, { ...item, param: item.name, value: profile[item.name] })}></div>
                                  <div className="profile-action remove" title="Remove" onClick={() => showRemove(true, { ...item, param: item.name, value: profile[item.name] })}></div>
                                  <div className="profile-action cancel" title="Cancel" onClick={() => showEdit(false, { ...item, param: item.name, value: profile[item.name] })}></div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : null}
          </div>
        ) : null}
        {!isProfile ? (
          <div className={'transcript' + (!isProfile ? ' overflow' : '')}/* style={{ height: (isProfile ? transcriptHeight + 'px' : 'auto') }}*/>
            {isProfile ? (
              <>
                <div className="close" onClick={() => handleTranscript(false)}></div>
                <div className="drag" onMouseDown={handleDragging}></div>
              </>
            ) : null}
            {renderMessages()}
          </div>
        ) : null}
        {(activity === false || (activity?.activity?.status !== 'completed' && activity?.activity?.type !== 'start')) && !isProfile ? (
          <div className="text-input">
            <input ref={ref} name="input" autoComplete="off" placeholder={isSending ? 'Give me a sec...' : (isProfile ? 'Tell your AI Guide' : 'Ask me anything')} value={message} disabled={!!isSending} onChange={(e) => handleInput(e)} onKeyDown={(e) => handleKey(e)} onFocus={() => handleTranscript(true)}></input>
            <div className="text-submit" onClick={() => postMessage(message)}></div>
          </div>
        ) : null}
      </div>
      {profileRemove ? (
        <div id="remove-container" className="popup-overlay">
          <div className="popup">
            <p>Are you sure you want to remove <strong>{profileRemove.label}</strong> from your profile?</p>
            <div className="actions">
              <div className="action action-primary" onClick={() => handleRemove(profileRemove)}>Remove</div>
              <div className="action action-secondary" onClick={() => showRemove(false, profileRemove)}>Cancel</div>
            </div>
          </div>
        </div>
      ) : null}
      {successMessage ? (
        <div id="success-container" className="popup-overlay">
          <div className="popup">
            <p>{successMessage}</p>
            <div className="actions">
              <div className="action action-primary" onClick={() => showSuccessMessage(null)}>OK</div>
            </div>
          </div>
        </div>
      ) : null}
      {showLink ? (
        <div id="link-container" className="popup-overlay">
          <div className="popup">
            <p>This link appears to be unreachable. It may be blocked by your network settings.</p>
            <div className="link-container" title="Click to Copy" onClick={() => handleCopy(showLink)}>
              <div className="link-text">{showLink}</div>
              <div className="link-copy"></div>
            </div>
            {showLinkCopied ? (
              <div className="link-copied">Link copied!</div>
            ) : null}
            <div className="actions">
              <div className="action action-primary" onClick={() => handleLink(showLink)}>Continue</div>
              <div className="action action-secondary" onClick={() => setShowLink(false)}>Cancel</div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Transcript;
